import React from 'react';
import { parseLandingHandoffContext } from '@/shared/navigation/landingHandoffContext';

/** Parse immutable Landing handoff state through the route-safe domain hook boundary. */
export function useLandingHandoffContext(search: string) {
  return React.useMemo(() => parseLandingHandoffContext(search), [search]);
}
